export interface ParsedPageNumberSelection {
  pageNumbers: string[]
  invalidTokens: string[]
}

export function normalizePageNumberToken(token: string) {
  return token.trim().toLocaleLowerCase()
}

export function parsePageNumberSelection(input: string): ParsedPageNumberSelection {
  const pageNumbers: string[] = []
  const invalidTokens: string[] = []
  const tokens = input.split(',').map(token => token.trim()).filter(Boolean)

  for (const token of tokens) {
    const singleMatch = token.match(/^\d+$/)
    if (singleMatch) {
      pageNumbers.push(token)
      continue
    }

    const rangeMatch = token.match(/^(\d+)\s*-\s*(\d+)$/)
    if (rangeMatch) {
      const [, startRaw, endRaw] = rangeMatch
      if (!startRaw || !endRaw) {
        invalidTokens.push(token)
        continue
      }

      const start = Number.parseInt(startRaw, 10)
      const end = Number.parseInt(endRaw, 10)
      if (!Number.isFinite(start) || !Number.isFinite(end) || start < 1 || end < 1 || start > end) {
        invalidTokens.push(token)
        continue
      }

      for (let pageNumber = start; pageNumber <= end; pageNumber += 1) {
        pageNumbers.push(String(pageNumber))
      }
      continue
    }

    invalidTokens.push(token)
  }

  return {
    pageNumbers: Array.from(new Set(pageNumbers.map(normalizePageNumberToken))),
    invalidTokens,
  }
}

export function isValidPageNumberSelection(input: string) {
  const trimmed = input.trim()
  if (!trimmed) {
    return false
  }

  const { pageNumbers, invalidTokens } = parsePageNumberSelection(trimmed)
  return invalidTokens.length === 0 && pageNumbers.length > 0
}
